import { render, staticRenderFns } from "./CheckboxWidget.vue?vue&type=template&id=30f90b42&scoped=true&"
import script from "./CheckboxWidget.vue?vue&type=script&lang=js&"
export * from "./CheckboxWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f90b42",
  null
  
)

export default component.exports